import { OutcomeOptions } from 'shared/constants/outcome';
import { SelectField } from 'shared/controls';

export function OutcomeDropdown() {
  const name = 'outcome';

  return (
    <SelectField
      name={name}
      label='Quote Outcome'
      options={OutcomeOptions}
      getOptionLabel={outcome => {
        return outcome ? outcome : '';
      }}
      getOptionSelected={(option, value) => {
        if (!option || !value) return true;
        return option === value;
      }}
    />
  );
}
